import type { QueryClient } from "@tanstack/react-query";
import { type LoaderFunction, replace } from "react-router";

import { TriggerService } from "@/shared/domain/triggers";
import { triggerQueryOptions } from "@/shared/domain/triggers/hooks";
import { makeAuthenticatedHttpClient } from "@/shared/http/makeAuthenticatedHttpClient";
import { Goto, triggerIdFromSegment } from "@/shared/navigation";

/**
 * The loader for `/triggers/:trigger` and every page under it. It
 * prefetches the trigger record if available.
 */
export function makeTriggerLoader(queryClient: QueryClient): LoaderFunction {
  return function loadTrigger({ params }) {
    const triggerId = triggerIdFromSegment(params.trigger ?? "");
    if (triggerId === null) {
      // Redirect to the list of triggers
      return replace(Goto.route.Triggers);
    }

    void makeAuthenticatedHttpClient()
      .then((httpClient) =>
        queryClient.prefetchQuery(
          triggerQueryOptions(triggerId, new TriggerService(httpClient)),
        ),
      )
      .catch(() => undefined);
    return null;
  };
}
